// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import styled from 'styled-components';

import { zIndex } from '@ecp/common/src/style/constant';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

const Container = styled.div`
  width: 100%;
  //height: 200px;

  z-index: ${zIndex.appBar};

  &.sticky {
    height: 81px;
  }
`;

const GnbWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;

  background-color: #ffffff;

  &.sticky {
    height: 81px;
    position: fixed;
    border-bottom: 1px solid rgb(223, 223, 223);
    top: 0;
  }
`;
const GnbHeaderContainer = styled(FlexBoxColumn)`
  width: 1540px;
  margin: 0 auto;

  background-color: ${(props) => props.theme.color.background.white};
  font-weight: ${(props) => props.theme.font.weight.demiLight};

  &.sticky {
    left: calc(max(50% - 770px, 45px));
    position: fixed;
    top: 0;
    height: 80px;
    padding: 15px 0 0;
    transition-duration: 0.2s;
  }
`;

export { Container, GnbWrapper, GnbHeaderContainer };
